import { LogoutOutlined, UserOutlined } from '@ant-design/icons'
import { Button, Drawer } from 'antd'
import { useNavigate } from 'react-router-dom'
import { userLogout } from '@/services'

interface MobileProfileDrawerProps {
  open: boolean
  onClose: () => void
}

function MobileProfileDrawer(props: MobileProfileDrawerProps) {
  const { open, onClose } = props
  const navigate = useNavigate()

  const onOpenProfile = () => {
    onClose()
    navigate('/user-profile')
  }

  const onLogout = async () => {
    await userLogout()
    navigate('/')
  }

  return (
    <Drawer
      className="mobile-profile-drawer"
      placement="bottom"
      closable={false}
      height={180}
      open={open}
      onClose={onClose}
      bodyStyle={{ padding: 16 }}
    >
      <div className="drawer-handle" />
      <Button type="text" icon={<UserOutlined />} onClick={onOpenProfile}>
        My Profile
      </Button>
      <Button type="text" icon={<LogoutOutlined />} onClick={onLogout}>
        Log Out
      </Button>
    </Drawer>
  )
}

export default MobileProfileDrawer
